import { create } from "zustand";
import { retrieve, save } from "../helpers/StorageHelper";
import { SIDEBAR_COLLAPSED, MOBILE_EXTENDED } from "../constants/localStorageKeys";

const getBoolean = (key, fallback = false) => {
  try {
    const value = retrieve(key);
    if (value === null) return fallback;
    if (value === "true") return true;
    if (value === "false") return false;
    return fallback;
  } catch {
    return fallback;
  }
};

const initialCollapsed = getBoolean(SIDEBAR_COLLAPSED, false);
const initialMobileExtended = getBoolean(MOBILE_EXTENDED, false);

const useSidebarStore = create((set, get) => ({
  sidebarCollapsed: initialCollapsed,
  sidebarExpanded: initialMobileExtended,
  isMobile: typeof window !== "undefined" ? window.innerWidth <= 992 : false,

  setIsMobile: (isMobile) => set({ isMobile }),

  toggleSidebar: (state) => {
    const newState = typeof state === "boolean" ? state : !get().sidebarCollapsed;
    save(SIDEBAR_COLLAPSED, String(newState));
    set({ sidebarCollapsed: newState });
    return newState;
  },

  toggleMobileState: (state) => {
    if (typeof state === "boolean") {
      save(MOBILE_EXTENDED, String(state));
      set({ sidebarExpanded: state });
      return state;
    }
    const newState = !get().sidebarExpanded;
    save(MOBILE_EXTENDED, String(newState));
    set({ sidebarExpanded: newState });
    return newState;
  },
}));

export default useSidebarStore;
